import { Card } from "@material-tailwind/react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import updatedLocale from "dayjs/plugin/updateLocale";
import { User } from "@/app/_components/context/user-context";
import { CalDelivery, DeliveryWithExtras } from "@/app/types/types";
import { DeliveryCalendarCardDesktopStatic } from "@/app/(app)/delivery-calendar/desktop/components/delivery-card";

interface DeliveryCalendarCardProps {
  deliveries: Record<string, DeliveryWithExtras[]>;
  userPermissions: string[];
  user: User;
}

export const DeliveryCalendarCard = ({
  deliveries,
  user,
  userPermissions,
}: DeliveryCalendarCardProps) => {
  dayjs.extend(utc);
  dayjs.extend(updatedLocale);

  dayjs.updateLocale("en", {
    weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  });

  const deliveryDataToTZ: { [key: string]: CalDelivery[] } =
    deliveries &&
    Object.keys(deliveries).reduce((acc, key) => {
      const localDate = new Date(key);
      const dayToAdd = `${dayjs.utc(localDate).format("YYYY-MM-DD")}`;
      acc[dayToAdd] = [];
      return acc;
    }, {});

  if (deliveries) {
    Object.entries(deliveries).forEach(([key, value]) => {
      value.forEach((delivery) => {
        const localDate = new Date(delivery.delivery.scheduledDeliveryDate);
        const dayToAdd = `${dayjs.utc(localDate).local().format("YYYY-MM-DD")}`;
        delivery.delivery.vin = delivery.vin;
        delivery.delivery.fsmManagerName = delivery.fsmManagerName;

        if (deliveryDataToTZ[dayToAdd]) {
          deliveryDataToTZ[dayToAdd].push(delivery.delivery);
        }
      });
    });
  }

  return (
    <Card className="w-1/2 outline outline-1 shadow-none outline-gray-200 rounded-sm min-w-0 max-h-[500px] overflow-y-auto">
      <div className="px-8 py-4">
        <div className="flex flex-row items-center justify-between border-b pb-2.5 pt-1.5">
          <div className="font-bold text-black items-center">
            Deliveries at a Glance
          </div>
        </div>

        <div className="flex justify-evenly">
          {deliveryDataToTZ &&
            Object.entries(deliveryDataToTZ).map(([key, value], index) => {
              const date = dayjs.utc(key).utc(true).format("ddd");

              return (
                <div
                  key={`delivery-${index}`}
                  className={"flex flex-col w-[30%]  items-center"}
                >
                  <div className="font-bold text-black">{date}</div>
                  <div className="h-[30vh] w-full flex justify-center  overflow-y-auto">
                    <div className="rounded-md mt-2 flex flex-col items-center w-full gap-2">
                      {value.length > 0 ? (
                        value
                          .sort((a, b) => {
                            return (
                              new Date(a.scheduledDeliveryDate).getTime() -
                              new Date(b.scheduledDeliveryDate).getTime()
                            );
                          })
                          .map((delivery) => {
                            const date = new Date(
                              delivery.scheduledDeliveryDate,
                            );
                            const formatted = date.toLocaleString("en-US", {
                              hour: "numeric",
                              minute: "numeric",
                              hour12: true,
                            });
                            const customerName =
                              userPermissions &&
                              (userPermissions.includes(
                                "VIEW_OTHER_CUSTOMERS",
                              ) || delivery.salesPerson == user.name
                                ? delivery.customer
                                : "*****");

                            return (
                              <DeliveryCalendarCardDesktopStatic
                                key={delivery.id}
                                delivery={delivery}
                                userPermissions={userPermissions}
                                user={user}
                              />
                            );
                          })
                      ) : (
                        <div className="h-full justify-start flex-col flex items-center w-full">
                          {" "}
                          <div
                            className="  w-[85%] h-[140px] m-x-auto flex justify-center items-center rounded-sm font-bold"
                            style={{
                              background: "#f8f8f8",
                            }}
                          >
                            {"No Deliveries"}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </Card>
  );
};

export default DeliveryCalendarCard;
